import { visitorApiInstance } from '@api/generated/axios-instance';
import type {
  DocumentDto,
  DocumentReadConfirmationStatusDto,
  DocumentUnreadCountDto,
  GetApiV1DocumentsParams,
  PagedResultOfDocumentDto,
  PostApiV1DocumentsBody,
  PostApiV1DocumentsSystemBody,
  SetDocumentTenantsDto,
  UpdateDocumentDto,
} from '@api/generated/visitor-api/model';

export const getApiV1Documents = (
  params?: GetApiV1DocumentsParams,
  signal?: AbortSignal,
) =>
  visitorApiInstance<PagedResultOfDocumentDto>({
    url: '/api/v1/documents',
    method: 'GET',
    params,
    signal,
  });

export const postApiV1Documents = (
  body: PostApiV1DocumentsBody,
  signal?: AbortSignal,
) =>
  visitorApiInstance<DocumentDto>({
    url: '/api/v1/documents',
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: body,
    signal,
  });

export const postApiV1DocumentsMultipart = (
  body: FormData,
  signal?: AbortSignal,
) =>
  visitorApiInstance<DocumentDto>({
    url: '/api/v1/documents',
    method: 'POST',
    data: body,
    signal,
  });

export const getApiV1DocumentsId = (id: string, signal?: AbortSignal) =>
  visitorApiInstance<DocumentDto>({
    url: `/api/v1/documents/${id}`,
    method: 'GET',
    signal,
  });

export const putApiV1DocumentsId = (
  id: string,
  body: UpdateDocumentDto,
  signal?: AbortSignal,
) =>
  visitorApiInstance<DocumentDto>({
    url: `/api/v1/documents/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    signal,
  });

export const deleteApiV1DocumentsId = (id: string, signal?: AbortSignal) =>
  visitorApiInstance<void>({
    url: `/api/v1/documents/${id}`,
    method: 'DELETE',
    signal,
  });

export const getApiV1DocumentsUnreadCount = (signal?: AbortSignal) =>
  visitorApiInstance<DocumentUnreadCountDto>({
    url: '/api/v1/documents/unread-count',
    method: 'GET',
    signal,
  });

export const postApiV1DocumentsIdReadConfirmation = (
  id: string,
  signal?: AbortSignal,
) =>
  visitorApiInstance<DocumentDto>({
    url: `/api/v1/documents/${id}/read-confirmation`,
    method: 'POST',
    signal,
  });

export const getApiV1DocumentsIdReadConfirmations = (
  id: string,
  signal?: AbortSignal,
) =>
  visitorApiInstance<DocumentReadConfirmationStatusDto>({
    url: `/api/v1/documents/${id}/read-confirmations`,
    method: 'GET',
    signal,
  });

export const postApiV1DocumentsSystem = (
  body: PostApiV1DocumentsSystemBody,
  signal?: AbortSignal,
) =>
  visitorApiInstance<DocumentDto>({
    url: '/api/v1/documents/system',
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: body,
    signal,
  });

export const putApiV1DocumentsIdTenants = (
  id: string,
  body: SetDocumentTenantsDto,
  signal?: AbortSignal,
) =>
  visitorApiInstance<DocumentDto>({
    url: `/api/v1/documents/${id}/tenants`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    signal,
  });

export const getApiV1DocumentsIdDownload = (id: string, signal?: AbortSignal) =>
  visitorApiInstance<Blob>({
    url: `/api/v1/documents/${id}/download`,
    method: 'GET',
    signal,
    responseType: 'blob',
  });

export const getApiV1DocumentsIdPreview = (id: string, signal?: AbortSignal) =>
  visitorApiInstance<Blob>({
    url: `/api/v1/documents/${id}/preview`,
    method: 'GET',
    signal,
    responseType: 'blob',
  });
